export default __webpack_public_path__ + "static/media/hamburger_close_button.d8f55d49.png";